module.exports = __webpack_public_path__ + "static/media/date.c445d827.svg";